import styled from 'styled-components'

const ShareStyle = styled.div`
	.link-wrap {
		&.disable {
			pointer-events: none;
		}
	}
`

export default ShareStyle
